/**
 * Section testimonial component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Image from '../image/image';

export default class SectionTestimonial extends PureComponent {

	render() {
		
		const { data } = this.props;
		
		return (
			
			<div className="section section-highlight text-center">
				<div className="container">

					{ !! data.title && <h2>{data.title}</h2> }

					<blockquote className="blockquote">
						{ !! data.text && <p>"{data.text}"</p> }
						{ !! data.photo.url && <figure className="blockquote-image"><Image data={data.photo} width="120" height="120"/></figure> }
						{ !! data.author && <footer className="blockquote-footer">{data.author} <cite title="Source Title">{data.position}</cite></footer> }
					</blockquote>

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-testimonial.js